<template>
    <div class="load-more">
        <div class="btnLoad" v-if="!isCompleted()" @click="loadMore">
            <a-icon type="loading" v-if="isLoading()" />
            {{ isLoading() ? "Loading..." : "Load more" }}

            <span class="number"> ( {{ totalReceived() }} loaded of {{ history().totalCount }} messages ) </span>
        </div>
        <div class="btnLoad completed" v-else>
            <a-icon type="cloud-sync" />
            {{ $t("message.allHistoryLoaded") }}
            <span class="number"> ({{ history().totalCount }} message )</span>
        </div>
    </div>
</template>
<script>
import { log2 } from "../../../utils/log2";
import { mapState } from "vuex";
import _ from "lodash";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";

const log = log2("LoadMoreMessage");
export default {
    name: "LoadMoreMessage",
    props: {
        conversationId: {
            type: String,
        },
        contactId: {
            type: String,
        },
    },
    data() {
        return {
            renderId: 1,
        };
    },
    computed: {
        ...mapState({
            isTeamChat: function (state) {
                return !!state.team.chats.find((x) => x._id === this.conversationId);
            },
            chatHistory: (state) => state.chat.chatHistory,
            messageHistory: (state) => state.chat.messageHistory,
        }),
    },
    methods: {
        loadMore() {
            log("loadMore");
            if (this.isTeamChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.TEAM_CONVERSATION_LOAD_MORE, {
                    conversationId: this.conversationId,
                });
            } else {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.ACTIVE_CONVERSATION_LOAD_MORE, {});
            }
        },
        history() {
            if (this.contactId) {
                return (
                    this.messageHistory[this.contactId] || {
                        data: [],
                        totalPage: 0,
                        totalCount: 0,
                        offset: -20,
                        limit: 20,
                        cachedChatIds: [],
                    }
                );
            } else {
                return (
                    this.chatHistory[this.conversationId] || {
                        data: [],
                        totalPage: 0,
                        totalCount: 0,
                        offset: -20,
                        limit: 20,
                        cachedChatIds: [],
                    }
                );
            }
        },
        isCompleted() {
            const history = this.history();
            const totalReceived = this.totalReceived();
            return totalReceived >= history.totalCount;
        },
        isLoading() {
            const history = this.history();
            return history.loading;
        },
        totalReceived() {
            const history = this.history();
            return history.data.filter((x) => x.messageType !== "conversation-separator").length;
        },
    },
    mounted() {},
    // watch: {
    //     chatHistory: {
    //         handler() {
    //             this.renderId++;
    //             this.$forceUpdate();
    //         },
    //         deep: true,
    //     },
    // },
};
</script>
<style lang="scss">
.sc-message.load-more {
    width: 300px !important;
}

.load-more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .btnLoad {
        color: #3899fe;
        cursor: pointer;
        user-select: none;

        &.completed {
            &:hover {
                text-decoration: none;
            }
        }

        .number {
            display: none;
        }

        &:hover {
            text-decoration: none;

            .number {
                display: inline;
            }
        }

        &:hover {
            text-decoration: underline;
        }

        &.disabled {
            color: #8a8a8a;
            cursor: unset !important;
        }
    }
}
</style>
